import {
  Component,
  computed,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { GcTextComponent } from '@ip-only/front-end-library';
import { FileHandlerComponent } from '../components/file-upload/file-handler.component';
import { ReportSelfInspectionWrapperComponent } from '../components/report-self-inspection-wrapper/report-self-inspection-wrapper.component';
import {
  FileInputData,
  SelfInspcetionWrapperData,
} from '../report-input-entities';
import { SelfInspectionBaseClassComponent } from '../self-inspection-base-class/self-inspection-base-class.component';

@Component({
  selector: 'app-self-inspection-files',
  imports: [
    ReportSelfInspectionWrapperComponent,
    FileHandlerComponent,
    GcTextComponent,
  ],
  templateUrl: './self-inspection-files.component.html',
  styleUrl: './self-inspection-files.component.scss',
})
export class SelfInspectionFilesComponent<T>
  extends SelfInspectionBaseClassComponent<T>
  implements OnInit
{
  @Input() data: FileInputData;
  @Input() wrapperData: SelfInspcetionWrapperData;
  isDeviation = input<boolean>();
  showOptionsButton = computed(() => {
    return !this.isDeviation() || !!this.data.fileData.files?.length;
  });

  @Output() viewImages = new EventEmitter();
  @Output() filesDownload = new EventEmitter<
    {
      fileName: string;
      fileId: string;
    }[]
  >();
  @Output() fileDelete = new EventEmitter<string>();

  get selfInspectionId(): string {
    return this.data.id;
  }
}
